/*
 *   Copyright (c) 2020 BuserNet Consulting LLC
 *   All rights reserved.
 */
import { Device } from '@capacitor/device';
import { Browser } from '@capacitor/browser';
import CapacitorConst from './capacitor.constant';

const capacitorService = () => {
  const content = {};
  content.deviceInfo = null;
  content.isStatusBarLight = true;
  content.isCapacitorMobileApp = false;
  content.isIphone = false;
  content.isIpad = false;
  content.isIos = false;
  content.isAndroid = false;

  content.openLinkInBrowser = (urlToOpen) => Browser.open({
    url: encodeURI(urlToOpen),
  });

  content.getModeOfHtml = () => document.getElementsByTagName('html')[0].getAttribute('mode');

  content.checkIfIos = () => /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

  content.setIsCapacitorMobileApp = async () => {
    const deviceInfo = await Device.getInfo();
    if (deviceInfo.platform !== CapacitorConst.platform.web) {
      content.isCapacitorMobileApp = true;
    }
  };
  content.getDeviceInfo = async () => {
    if (content.deviceInfo) {
      return content.deviceInfo;
    }
    const deviceInfo = await Device.getInfo();
    content.deviceInfo = deviceInfo;
    content.setHeaderDefaultHeight();
    if (deviceInfo.platform !== CapacitorConst.platform.web) {
      content.isCapacitorMobileApp = true;
    }
    if (deviceInfo.platform === CapacitorConst.platform.ios) {
      content.isIos = true;
      // Setting model iphone or ipad
      if (deviceInfo.model === CapacitorConst.model.iPhone) {
        content.isIphone = true;
      } else if (deviceInfo.model === CapacitorConst.model.iPad) {
        content.isIpad = true;
      }
    }
    if (deviceInfo.platform === CapacitorConst.platform.android) {
      content.isAndroid = true;
    }
    return content.deviceInfo;
  };
  return content;
};
export default capacitorService();
